module.exports = __webpack_public_path__ + "static/blog29-affafddad727aff99b9d072ff21b0bcd.png";